import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { BaseView } from '../../../../view/base-view';
import { environment } from '../../../../../environments/environment';
import { VisitasApiService } from '../../../../service/api/visitas-api.service';
import { Router } from '@angular/router';
import { RequestButtonTypes } from '../../../../common/components/request-button/request-button.component';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import moment from 'moment';
import { Filtering } from '../../../../service/filtering/filtering';
import { Observable } from 'rxjs';
import { TrasiegoModel } from 'src/app/models/visitas/trasiego.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { ModelDatasetInternalInterface } from './model-dataset-internal.interface';
import { TreeNode } from 'primeng/api';

interface Plaga {
    name: string;
    value: string;
}

import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { VisitasTrasiegoFormDefinition } from './visitas-trasiego-form/form-control/form-definition';
@Component({
    selector: 'app-visitas-trasiego',
    standalone: false,
    templateUrl: './visitas-trasiego.component.html',
    styleUrls: ['./visitas-trasiego.component.scss']
})
export class VisitasTrasiegoComponent extends BaseView<TrasiegoModel> implements OnInit {
    public serverUrl = environment.serverUrl;

    public form: VisitasTrasiegoFormDefinition | null = null;


    /** VARIABLES ESTADISTICAS */
    public fecha = '';
    public loadingCharts = true;
    public notResults = false;
    public filter: Filtering<TrasiegoModel> = new Filtering<TrasiegoModel>();
    public showWarning = false;
    public basicOptions: Record<string, unknown> = {
        elements: {
            line: {
                borderWidth: 3
            },
            point: {
                hitRadius: 8,
                radius: 4
            }
        },
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    boxWidth: 18,
                    color: '#334155'
                },
                position: 'top'
            }
        },
        responsive: true,
        scales: {
            x: {
                ticks: {
                    color: '#334155'
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: '#334155'
                }
            }
        }
    };
    public es = {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre',
            'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Borrar'
    };

    public chartShelly: ChartStructure | undefined;
    public finalChartShelly: ChartStructure | undefined;


    public list_devices: { label: string; value: number }[] = [];
    public list_device_obs$: Observable<{ label: string; value: number; }[]> | undefined;
    fecha_formatted = '';
    public realtime = false;

    /** FIN DE VARIEBLES ESTADISTICAS */

    public override filtering: Filtering<TrasiegoModel> = new Filtering<TrasiegoModel>();
    public trampasOptions: [{name: string, value: string | null}] = [{name: '...', value: null}];
  
    public fincaName = environment.features.fincaName;
    public parcelaName = environment.features.parcelaName;
    public fincasName = environment.features.fincasName;
  
    public deleteRequest: RequestHandler<TrasiegoModel> = this.visitasApi.visitasTrasiego.DELETE;
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;
    public getRequest = this.visitasApi.visitasTrasiego.GET;
    public menuItemId = 'visitas-trasiego';
  
    public currentWeek: {name: string, value: string | null} = {name: 'TODAS', value: null};
    public currentYear: {name: string, value: string | null} = {name: 'TODOS', value: null};
    public weeks: {name: string, value: string | null}[] = [];
    public years: {name: string, value: string | null}[] = [];
    public cols: ColInterface[] = [];
  

    public plagaSelected: Plaga[] = []; 

    public plagasList: Plaga[] = [
        {name: 'Trips', value: 'Trips'},
        {name: 'Empoasca', value: 'Empoasca'},
        {name: 'Stethorus', value: 'Stethorus'},
        {name: 'Sciara', value: 'Sciara'},
        {name: 'Scatella', value: 'Scatella'},
        {name: 'Parasitoides', value: 'Parasitoides'},
        {name: 'Pulgón', value: 'Pulgón'},
        {name: 'Otros', value: 'Otros'},
        {name: 'Mosca común', value: 'Mosca común'},
        {name: 'Mosquito', value: 'Mosquito'},
        {name: 'Mosca blanca', value: 'Mosca blanca'}
    ];

    public trampaSelected = {name: '...', value: null};

    public trampas: {name: string, value: string | null}[] = [
        {name: '...', value: null},
        {name: 'T.S1', value: 'T.S1'},
        {name: 'T.S2', value: 'T.S2'},
        {name: 'T.S3', value: 'T.S3'},
        {name: 'T.S4', value: 'T.S4'},
        {name: 'T.SEMILLERO', value: 'T.SEMILLERO'},
        {name: 'T.S5', value: 'T.S5'},
        {name: 'T.S6', value: 'T.S6'},
        {name: 'T.S7', value: 'T.S7'},
        {name: 'T.S8', value: 'T.S8'},
        {name: 'T.S9', value: 'T.S9'},
        {name: 'T.S10', value: 'T.S10'},
        {name: 'T.MICROS', value: 'T.MICROS'},
        {name: 'FC-T.S1', value: 'FC-T.S1'},
        {name: 'FC-T.S2', value: 'FC-T.S2'},
        {name: 'FC-T.S3', value: 'FC-T.S3'}
    ];

    public plagas: string[] = [];

    public dataPlagasChart: ChartStructure = {
        labels: [],
        datasets: []
    };

    private readonly chartColors: string[] = [
        '#d9b98c',
        '#2a7f8f',
        '#ca3cb4',
        '#d8ef46',
        '#f05ac7',
        '#5f6368',
        '#8ca15a',
        '#dd4164',
        '#c9828d',
        '#c45ac7',
        '#7c1cb5'
    ];

    public get chartModalConfiguration(): ChartModalConfiguration {
        return {
            data: this.dataPlagasChart,
            emptyMessage: 'No hay datos para las opciones seleccionadas.',
            loading: this.loadingCharts,
            modalKey: 'grafica',
            options: this.basicOptions,
            title: 'Cantidad Plagas',
            type: 'line'
        };
    }

    constructor(
        private router: Router,
        private dashboard: DashboardService,
        private visitasApi: VisitasApiService
    ) {
        super(dashboard, visitasApi.visitasTrasiego.GET, visitasApi.visitasTrasiego.DELETE);

        this.currentYear = {name: moment().format('YYYY'), value: moment().format('YYYY')};
        this.getRequest.injectParams({ano: this.currentYear.value} as never, 'visitas/trasiego_get');

        const year1 = parseInt(moment().subtract(2, 'year').format('YYYY'), 10);
        const year10 = parseInt(moment().add(9, 'years').format('YYYY'), 10);

        this.weeks.push({name: 'TODAS', value: null});
        this.years.push({name: 'TODOS', value: null});

        for (let i = 1; i <= 54; i++) {
            this.weeks.push({name: i.toString(), value: i.toString()});
        }
        for (let i = year1; i <= year10; i++) {
            this.years.push({name: i.toString(), value: i.toString()});
        }
    }

    ngOnInit() {
        this.currentYear = {name: moment().format('YYYY'), value: moment().format('YYYY')};
        this.dashboard.setMenuItem(this.menuItemId);
        this.dashboard.setHeaderTitle('Visitas Trasiego');

        this.filtering.addFilter((copy: TreeNode<TrasiegoModel>[] | void) => (copy as TreeNode<TrasiegoModel>[]).filter(row => {
            const data = row as unknown as TrasiegoModel;

            const weekCond = this.currentWeek.value != null
                ? data.semana === this.currentWeek.value
                : true;
            const yearCond = this.currentYear.value != null
                ? data.ano === this.currentYear.value
                : true;
            const trampaCond = this.trampaSelected.value != null
                ? data['trampa'] === this.trampaSelected.value
                : true;
            const plagaCond = this.plagaSelected.length > 0
                ? this.plagaSelected.some(p =>
                    [1, 2, 3, 4, 5, 6].some(i => (data as never)['plaga' + i] === p.value)
                )
                : true;

            return weekCond && yearCond && trampaCond && plagaCond;
        }));
        this.visitasApi.visitasPLAGAS_TRASIEGO_GET.toPromise()
            .then(plagas => {
                this.plagas = (plagas || []).map((it: TrasiegoModel) => it.plaga1 ?? '');
                this.visitasApi.visitasTrasiego.GET.response(() => {
                    this.formatTable();
                });
                return;
            }).catch (e => {
                console.log('catch en getPosition: ' + e);
            }
            );

        // this.fillCharts();
    }

    public filterValues() {
        this.filtering.filter();
    }

    public globalConditionalStyle(_value: string, cell: ColInterface): ColStylesInterface {
        if (!['finca_nombre', 'parcela_nombre', 'ano'].includes(cell.field)) {
            return {
                textAlign: 'center'
            };
        } else {
            return {};
        }
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<TrasiegoModel>): string {
        const trasiego = row.data as TrasiegoModel;
        const hasPlagas = Object.keys(trasiego).some(it => it.includes('plaga'));

        if (hasPlagas) {
            for (const i of [1, 2, 3, 4, 5, 6]) {
                if (trasiego['plaga' + i] && (col.field === trasiego['plaga' + i])) {
                    return trasiego['cantidad' + i] as string;
                }
            }
        }
        return value;
    }

    public formatTable() {
        if (this.plagas && this.getRequest.value) {
            this.cols = [
                {field: 'finca_nombre', header: this.fincaName},
                {field: 'parcela_nombre', header: this.parcelaName},
                {field: 'semana', header: 'Semana'},
                {field: 'trampa', header: 'Trampa'},
            ];

            this.plagas.forEach(plaga => {
                this.cols.push({
                    field: plaga,
                    header: plaga
                });
            });
  
            this.filterValues();
        }
    }

    public edit(data: TrasiegoModel) {
        this.router.navigate(['dashboard', 'editar-visita-trasiego', data.id]);
    }

    public override show(modal: string, data: TrasiegoModel) {
        let x;

        this.model = data;
    
        if (modal !== 'grafica') {
            this.canShow[modal] = true;
        }

        if (modal === 'grafica') {
            try {
                if (this.trampaSelected.value != null && this.currentYear.value != null && this.plagaSelected.length > 0) {
                    this.showWarning = false;
                    this.fillCharts(this.currentWeek.value, this.trampaSelected.value, this.currentYear.value, this.plagaSelected);
                    this.canShow[modal] = true;
                } else {
                    this.showWarning = true;
                }
            } catch (error) {
                console.error(error);

                this.showWarning = true;
            }
        }

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x]) {
                this.canShow[x] = false;
            }
        }
    
        this.setModalForm(modal);
    }

    public override hide(modal: string) {
        this.model = {} as TrasiegoModel;
        this.canShow[modal] = false;
        if (this.deleteRequest) {
            this.deleteRequest.reset();
        }
    }

    public fillCharts(semana: string | null, trampa: string, ano: string, plagas: Plaga[]): void {
        this.loadingCharts = true;
        this.notResults = false;

        const rows = this.getChartRows(semana, trampa, ano);
        const weeks = this.getChartWeeks(rows, semana);
        const datasets = plagas
            .map((plaga: Plaga, index: number): ModelDatasetInternalInterface => {
                const color = this.getChartColor(index);

                return {
                    backgroundColor: color,
                    borderColor: color,
                    data: weeks.map((week: string): number => this.getPestTotalByWeek(rows, week, plaga.value)),
                    fill: false,
                    label: plaga.name,
                    tension: 0.4
                };
            })
            .filter((dataset: ModelDatasetInternalInterface): boolean => dataset.data.some((value: number): boolean => value > 0));

        this.dataPlagasChart = {
            datasets,
            labels: weeks.map((week: string): string => `Semana ${week}`)
        };
        this.notResults = datasets.length === 0;
        this.loadingCharts = false;
    }

    private getChartRows(semana: string | null, trampa: string, ano: string): TrasiegoModel[] {
        const value = this.getRequest.value;

        if (!Array.isArray(value)) {
            return [];
        }

        return value
            .map((row: TrasiegoModel | TreeNode<TrasiegoModel>): TrasiegoModel | undefined => this.getTrasiegoData(row))
            .filter((row: TrasiegoModel | undefined): row is TrasiegoModel => !!row)
            .filter((row: TrasiegoModel): boolean => this.matchesChartFilters(row, semana, trampa, ano));
    }

    private getTrasiegoData(row: TrasiegoModel | TreeNode<TrasiegoModel>): TrasiegoModel | undefined {
        const possibleTreeNode = row as TreeNode<TrasiegoModel>;

        if (this.isTrasiegoModel(possibleTreeNode.data)) {
            return possibleTreeNode.data;
        }

        if (this.isTrasiegoModel(row)) {
            return row;
        }

        return undefined;
    }

    private isTrasiegoModel(value: unknown): value is TrasiegoModel {
        return typeof value === 'object' && value !== null && ('semana' in value || 'ano' in value || 'plaga1' in value);
    }

    private getChartColor(index: number): string {
        return this.chartColors[index % this.chartColors.length] ?? '#42A5F5';
    }

    private matchesChartFilters(row: TrasiegoModel, semana: string | null, trampa: string, ano: string): boolean {
        const rowWeek = this.toComparableString(row.semana);
        const rowYear = this.toComparableString(row.ano);
        const rowTrap = this.toComparableString(row['trampa']);
        const weekMatches = semana == null || rowWeek === this.toComparableString(semana);

        return weekMatches && rowYear === this.toComparableString(ano) && rowTrap === this.toComparableString(trampa);
    }

    private getChartWeeks(rows: TrasiegoModel[], selectedWeek: string | null): string[] {
        if (selectedWeek != null) {
            return rows.length > 0 ? [this.toComparableString(selectedWeek)] : [];
        }

        return Array.from(new Set(rows.map((row: TrasiegoModel): string => this.toComparableString(row.semana))))
            .filter((week: string): boolean => week !== '')
            .sort((firstWeek: string, secondWeek: string): number => Number(firstWeek) - Number(secondWeek));
    }

    private getPestTotalByWeek(rows: TrasiegoModel[], week: string, plaga: string): number {
        return rows
            .filter((row: TrasiegoModel): boolean => this.toComparableString(row.semana) === week)
            .reduce((total: number, row: TrasiegoModel): number => total + this.getPestTotalFromRow(row, plaga), 0);
    }

    private getPestTotalFromRow(row: TrasiegoModel, plaga: string): number {
        const pestFieldIndexes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

        return pestFieldIndexes.reduce((total: number, index: number): number => {
            const currentPest = this.toComparableString(row[`plaga${index}`]);

            if (currentPest !== this.toComparableString(plaga)) {
                return total;
            }

            return total + this.parseChartNumber(row[`cantidad${index}`]);
        }, 0);
    }

    private parseChartNumber(value: string | number | boolean | Date | null | undefined): number {
        const normalizedValue = String(value ?? '')
            .trim()
            .replace(',', '.');
        const parsedValue = Number(normalizedValue);

        return Number.isFinite(parsedValue) ? parsedValue : 0;
    }

    private toComparableString(value: string | number | boolean | Date | null | undefined): string {
        return String(value ?? '').trim();
    }

    private setModalForm(modal: string): void {
        if (modal !== 'info' && modal !== 'delete') {
            return;
        }

        const formType = modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE;

        this.form = new VisitasTrasiegoFormDefinition(formType, this.model, undefined);
    }
}


interface ChartStructure {
    labels: string[];
    datasets: ModelDatasetInternalInterface[];
}

interface ChartModalConfiguration {
    modalKey: string;
    title: string;
    type: string;
    data: ChartStructure;
    options: Record<string, unknown>;
    loading: boolean;
    emptyMessage: string;
}
